export enum PubsubKeyEnum {
  validationTokenSuccess = 'validationTokenSuccess',
  authenticationTokenModalEvent = 'authenticationTokenModalEvent',
  validateTokenStatus = 'validateTokenStatus',
  paymentsExecutePayment = 'executePayment',
  systemAuthenticationErrorEvent = 'systemAuthenticationErrorEvent',
  systemAuthenticationLockToken = 'systemAuthenticationLockToken',
  authenticationModalClosed = 'authenticationModalClosed',
  TOAST = 'toast',
  CHANGE_PERMISSIONS_MENU = 'CHANGE_PERMISSIONS_MENU'
}
